import { getI18n } from '@/plugins/i18n'
import { useSupplierBrandColumn } from '@/composables/data-grid-column'
import { getTranslatedField } from '@/plugins/i18n'

import * as dataGrid from '@/composables/data-grid'
import { useAccountingStore } from '@/stores/accounting.store'

export const useColumns = () => {
  const i18n = getI18n()
  const accountingStore = useAccountingStore()

  const getFilteredTradeAccounts = (type) => ({
    store: accountingStore.getLocalizedTradeAccounts(),
    filter: (item) => item.type === accountingStore.tradeAccountTypesEnum.PURCHASE_SALE || item.type === type,
    sort: 'code',
  })

  const getFilteredFinancialCenters = (type) => ({
    store: accountingStore.getLocalizedFinancialCenters(),
    filter: (item) => item.type === accountingStore.financialCenterTypesEnum.COST_INCOME || item.type === type,
    sort: 'code',
  })

  return [
    {
      type: 'buttons',
      buttons: [{template: 'editButtonsTemplate'}],
      width: '4rem',
      visibleIndex: 0,
      fixed: false
    },
    useSupplierBrandColumn({ sortOrder: 'asc' }),
    {
      dataField: 'code',
      caption: i18n.t('common.code'),
      sortOrder: 'asc',
      width: '10rem',
      validationRules: [{ type: 'required' }],
    },
    {
      dataField: 'name',
      caption: i18n.t('common.description'),
      calculateCellValue: (rowData) => rowData.name ?? getTranslatedField(rowData, 'name'),
      setCellValue: (newData, value) => { newData.name = value },
      allowFiltering: false,
      allowSorting: false,
      validationRules: [{ type: 'required' }],
    },
    {
      dataField: 'intrastat_code',
      caption: i18n.t('common.intrastatCode'),
    },
    {
      dataField: 'financial_center_cost_ref',
      caption: i18n.t('common.financialCenterCost'),
      lookup: dataGrid.useLookup({ dataSource: getFilteredFinancialCenters(accountingStore.financialCenterTypesEnum.COST) }),
    },
    {
      dataField: 'financial_center_income_ref',
      caption: i18n.t('common.financialCenterIncome'),
      lookup: dataGrid.useLookup({ dataSource: getFilteredFinancialCenters(accountingStore.financialCenterTypesEnum.INCOME) }),
    },
    {
      dataField: 'trade_account_purchase_ref',
      caption: i18n.t('common.tradeAccountPurchase'),
      lookup: dataGrid.useLookup({ dataSource: getFilteredTradeAccounts(accountingStore.tradeAccountTypesEnum.PURCHASE) }),
    },
    {
      dataField: 'trade_account_sale_ref',
      caption: i18n.t('common.tradeAccountSale'),
      lookup: dataGrid.useLookup({ dataSource: getFilteredTradeAccounts(accountingStore.tradeAccountTypesEnum.SALE) }),
    },
    {
      caption: `${i18n.t('common.isLocked')}`,
      dataType: 'boolean',
      dataField: 'is_locked',
    },
  ]
}
